module.exports = __webpack_public_path__ + "img/hirunomi_banner.f75ff70f.jpg";